<div class="winner-alert default-overlay" appAlert [show]="show" (showChange)="showChange($event)">
  <div class="images">
    <img src="assets/images/pot-v3.png" />
    <img src="assets/images/dwarf.png" />
  </div>
  <div class="title">
    <div>WINNER</div>
    <div>{{ bet }}</div>
  </div>
  <div class="description">
    You won
    <div>{{ chips | number: '0.0-2' }} Coins</div>
    and
    <div>{{ bonus | number: '0.0-2' }} Bonus Coins</div>
  </div>
  <div class="xmark-container" (click)="showChange(false)">
    <fa-icon size="xl" [icon]="faXmark"></fa-icon>
  </div>
</div>
